import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { NotificationsRepository } from 'app/state/notifications.repository';
import { STYLES } from 'app/helpers/constants/styles.constants';
import { IMenuItem } from '../../../components/menu-item/menu-item.component';

@UntilDestroy()
@Component({
  selector: 'app-home-menu-grid',
  templateUrl: './home-menu-grid.component.html',
  standalone: false,
})
export class HomeMenuGridComponent implements OnInit {
  menuItems: IMenuItem[] = [];
  tenantPrimaryColor = STYLES.primaryColor;

  constructor(
    public router: Router,
    private generalDataRepository: GeneralDataRepository,
    private notificationsService: NotificationsRepository,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.generalDataRepository.allMobileMenuItems$,
      this.generalDataRepository.allGeneralData$,
      this.notificationsService.notificationCount$,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([menuItems, generalData, notifications]) => {
        this.tenantPrimaryColor =
          generalData.customTenantProperties?.primaryColor ?? STYLES.primaryColor;

        const featuresData = generalData.tenantMenuItemsData ?? [];

        // Work on copies — the source array is shared with the legacy mobile
        // menu, and we mutate the display name below.
        this.menuItems = menuItems.map((item) => {
          const copy: IMenuItem = { ...item };

          const featureData = featuresData.find(
            (d) => d.name.toLowerCase() === copy.name.toLowerCase(),
          );
          if (featureData) {
            copy.name = featureData.customTitle || featureData.name.toLowerCase();
          }

          const match = notifications.find(
            (n: any) => n.groupName === copy.name,
          );
          copy.notificationsCount = match ? match.count : 0;

          return copy;
        });
      });
  }
}
